import { AutoInstalledState } from "@domain/General/Enums/AutoInstalledState";
import type { GpsCoordinates } from "@services/GpsCoordinates";

export class UserSettings
{
    enableDemoLinkedCards = false;
    enableDemoBankAccount = false;
    enableDemoTransactions = false;
    enableDemoCarePlanSettings = false;
    isFirstMarketplaceVisit = true;
    showConciergeMessages = false;
    hasHealthMonitorWarning = false;
    hasTheftRecoveryDevice = true;
    reverseConditionIndicators = false;
    expandProfileActions = false;
    enableDealerMode = false;
    enableCustomGpsCoordinates = false;
    customGpsCoordinates: GpsCoordinates | undefined;
    healthMonitorEnabledState: AutoInstalledState = AutoInstalledState.Auto;
    isPairing = false;
    wasHealthMonitorPaired = false;
    numberOfPairingAttempts = 0;
    skipHealthMonitorReminderUntil: string | null = null;
    skipUpdateOdometerReminderUntil: string | null = null;
}